/**
 * צלילי מסוף מינימליים דרך Web Audio API — ללא קבצי אודיו חיצוניים.
 * כל הצלילים קצרים ועדינים (ביפים סינתטיים), בהתאם לאסתטיקת הטרמינל.
 */
let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (typeof window === 'undefined') return null;
  const AudioCtx = window.AudioContext ?? (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!AudioCtx) return null;
  if (!ctx) ctx = new AudioCtx();
  if (ctx.state === 'suspended') void ctx.resume();
  return ctx;
}

function beep(freq: number, durationMs: number, type: OscillatorType = 'square', gain = 0.045): void {
  const audio = getCtx();
  if (!audio) return;
  const osc = audio.createOscillator();
  const g = audio.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.value = gain;
  osc.connect(g);
  g.connect(audio.destination);
  const now = audio.currentTime;
  g.gain.setValueAtTime(gain, now);
  g.gain.exponentialRampToValueAtTime(0.0001, now + durationMs / 1000);
  osc.start(now);
  osc.stop(now + durationMs / 1000 + 0.02);
}

export const terminalSound = {
  key: () => beep(620 + Math.random() * 80, 18, 'square', 0.02),
  boot: () => {
    beep(220, 90, 'sawtooth', 0.05);
    setTimeout(() => beep(330, 90, 'sawtooth', 0.05), 100);
  },
  success: () => {
    beep(660, 90, 'square', 0.05);
    setTimeout(() => beep(990, 140, 'square', 0.05), 110);
  },
  error: () => beep(140, 260, 'sawtooth', 0.06),
  alert: () => {
    beep(880, 120, 'square', 0.05);
    setTimeout(() => beep(880, 120, 'square', 0.05), 180);
  },
  click: () => beep(440, 30, 'square', 0.03),
};

export type SoundName = keyof typeof terminalSound;

export function playSound(name: SoundName, enabled: boolean): void {
  if (!enabled) return;
  try {
    terminalSound[name]();
  } catch {
    // Web Audio עלול להיכשל לפני אינטראקציית משתמש ראשונה בדפדפן — לא קריטי
  }
}
